<template>
  <div class="product-detail" :id="`product_sku__${product.sku}`">

    <!-- TODO: Site maintenance (Hardcode) -->
    <!-- <div v-if="!forceShowDonationBox" class="page-title text-center" style="padding-top: 3rem;">
      <h1 class="mt-2 px-2 text-center">ปิดปรับปรุงระบบ</h1>
      <h5 class="mt-2 px-2 text-center campaign-title">วันที่ 20 มิ.ย. 2566 <br />เวลา 20:00 น. - 22:00 น.</h5>
      <div class="text-center mb-3 mb-md-5 small">ขออภัยในความไม่สะดวก</div>
    </div> -->

    <div class="wrap-container">
      <h1 class="page-title text-center" v-if="false && isMainCampaign">{{ title }}</h1>
      <h1 class="page-title page-title--campaign text-center px-2" v-else>บริจาคให้โครงการ</h1>
      <h2 v-if="true || !isMainCampaign" class="text-center campaign-title">
        {{product.name}}
      </h2>
      <div class="">
        <div class="mx-auto text-center float-none">
          <div v-if="true || !isMainCampaign" class="text-center mb-3 text-blue text-lg m-0" v-html="product.description"></div>
        </div>
      </div>

      <!--<donate-step-bar @clickstep="onStep" />-->

      <div class="">
        <div v-if="ready">
          <product-list-item
            ref="form"
            v-if="product && product.sku"
            extraClasses="product--inline"
            :product="product"
            :initialQuantity="1"
            :cartMode="false"
            :showAttributes="true"
            :useCarousel="true"
            :titleAsLink="false"
            :showTimeBeforeAvailable="true"/>

          <!-- <div v-html="product.description"></div> -->
          <div class="alert alert--danger text-left" v-if="product.notice">
            <strong>หมายเหตุ</strong>
            <div v-html="product.notice"></div>
          </div>
        </div>

        <div v-if="!ready">
          <loader></loader>
        </div>
      </div>
    </div>

    <banner></banner>
  </div>
</template>

<script>
  import Vue from 'vue'
  import ProductListItem from './ProductListItem.vue'
  import Loader from './Loader.vue'
  import Banner from './Banner.vue'
  import DonateStepBar from '@/components/DonateStepBar'

  export default {
    components: {
      DonateStepBar,
      Loader,
      Banner,
      ProductListItem
    },
    name: 'ProductDetail',
    props: {
      product: { type: Object, required: true }
    },
    data () {
      return {
        title: 'บริจาคเข้ากองทุน'
      }
    },
    computed: {
      ready () {
        return this.product && this.product.sku
      },
      isMainCampaign () {
        return this.product.sku === Vue.config.MAIN_PRODUCT_SKU
      }
      // forceShowDonationBox () {
      //   return this.$route.query.force_show_donation_box === 'satisfy-ointment-triptych-glitch'
      // }
    },
    methods: {
      onStep (idx) {
        if (idx) this.$refs.form.donate()
      }
    }
  }
</script>

<style scoped lang="scss">
  .wrap-container {
    background: #f9f9f9;
    max-width: 630px;
    padding: 20px;
    border-radius: 15px;
    margin: 0 10px 10px;
    @media only screen and (min-width: 768px) {
       padding: 30px 20px;
       margin: 0 auto;
    }
  }
  
  .product-list-item {
    background-color: #f9f9f9;
    max-width: 400px;
    margin: 0 auto;
  }

  .product__catalog_items .product-list-item {
    background-color: inherit;
  }

  .page-title {
    color: #153050;
    font-family: 'Wittaya-Medium';
    font-size: 2rem;
    margin-bottom: 15px;
    &--campaign {
      font-family: 'Wittaya-Light';
      font-weight: 300;
      font-size: 1.25rem;
      margin: 0;
    }
  }
  .campaign-title {
    font-size: 1.5rem;
    @media only screen and (min-width: 768px) {
       font-size: 1.75rem;
    }
  }
  h3 {
    word-break: break-word;
    word-wrap: break-word;
  }
  .text-lg {
    font-size: 1.15rem;
    > p {
      margin: 0;
    }
  }
  // .product-detail {
  //   min-height: 70vh;
  // }
</style>



// WEBPACK FOOTER //
// ProductDetail.vue?b799cc20